<template>
  <div class="flex flex-column justify-center">
    <carousel :per-page="1" :navigationEnabled="true" paginationActiveColor="#272727" paginationColor="#ccc" :paginationEnabled="false"
              :loop="true" :autoplay="true">
      <slide v-for="n in 5" :key="n">
        <slide-info :text="$t('users.subscription.info'+n)" :img="`/static/assets/subscription/${n}.png`"/>
      </slide>
    </carousel>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import { Carousel, Slide } from 'vue-carousel'
  import SlideInfo from './SlideInfo.vue'

  export default {
    name: 'subscription-info',
    components: {
      Carousel,
      Slide,
      SlideInfo
    },
    computed: {
      ...mapGetters('user', [
        'error',
        'loading',
        'isProducer'
      ])
    },
    methods: {
      ...mapActions('user', [
        'resetError'
      ])
    }
  }
</script>

<style scoped lang="scss">
  @import '~@/variables.scss';

  .payment {
    height: 150px;
  }
</style>



// WEBPACK FOOTER //
// src/components/modals/subscription/SubscriptionInfo.vue